<template>

            <div class="cl-search_filter">
              <h3 class="cl-search_filter_title">{{filter.label}}</h3>  
              <div  v-for="val of filter.values" :key="val">
                <label class="cl-search_filter_checkbox">{{val}}
                  <input type="checkbox"  :value="val" class="flex_shrinkno" v-model="selectedFacets" @change="dispatchAction">
                </label>
              </div>
            </div>
</template>
<script>
 
export default {
  name: 'checkbox-filter',
  props: {
    filter: {
      type: Object,
      default: () => {},
    }
  },
  data () {
      return {
        selectedFacets: []
      }
    },
  methods:{
    dispatchAction(){
     var event = new CustomEvent("filterUpdate", {
        detail: {
          filtertype: this.filter.filtertype,
          filterparent: this.filter.filterparent,
          newvalue: this.selectedFacets
        }
      });
      this.$emit('filterUpdate',event);
    }
  }

}
</script>



// WEBPACK FOOTER //
// src/plugins/SearchPlugin/components/FilterCheckbox.vue